import { render, staticRenderFns } from "./FormFieldsStep.vue?vue&type=template&id=0366764d&scoped=true"
import script from "./FormFieldsStep.vue?vue&type=script&lang=js"
export * from "./FormFieldsStep.vue?vue&type=script&lang=js"
import style0 from "./FormFieldsStep.vue?vue&type=style&index=0&id=0366764d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0366764d",
  null
  
)

export default component.exports